/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { fetchFeaturedDashboardNews } from '../../../../_redux/features/dashboard/dashboardSlice';
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { DownloadOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';

const FeaturedNewsDashboard: React.FC = () => {
    const intl = useIntl()
    const dispatch = useDispatch<any>()
    const { dashboardFeaturedNews, isFWLoading } = useSelector((state: any) => state.dashboard)

    useEffect(() => { dispatch(fetchFeaturedDashboardNews()) }, [])

    const downloadAllFiles = (e: React.MouseEvent, links: string[]) => {
        e.preventDefault();
        if (!links || links.length === 0) return;

        links.forEach((url, index) => {
            setTimeout(() => {
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.setAttribute('download', url.split('/').pop() || 'download');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }, index * 300);
        });
    };

    const renderedItems = dashboardFeaturedNews.map((item, index) => (
        <div key={index} className='card mb-5 overflow-hidden card-light-shadow ' style={{ height: '160px' }}>
            <div className='d-flex h-100'>
                <div className='w-150px w-md-200px flex-shrink-0'>
                    <div 
                        className='h-100 w-100' 
                        style={{ 
                            backgroundImage: `url(${item.fileContent})`, 
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    ></div>
                </div>

                <div className='d-flex flex-column flex-grow-1 p-2 ps-5 overflow-hidden'>
                    
                    {/* Sabit Başlık */}
                    <a href='#' className='text-dark fw-bold text-hover-primary fs-5 mb-2 d-block text-start'>
                        {item.title}
                    </a>

                    {/* Kaydırılabilir (Scrollable) Body */}
                    <div 
                        className='flex-grow-1 overflow-auto pe-2 custom-scroll text-gray-600 fs-7'
                    >
                        <div dangerouslySetInnerHTML={{ __html: item.body }}></div>
                    </div>
                    {item.downloadLinks && item.downloadLinks.length > 0 &&
                        <div className='mt-2 mb-0 pt-2 border-top'>
                        <a 
                                href='#'
                                onClick={(e) => downloadAllFiles(e, item.downloadLinks)}
                                className='text-primary fw-bold fs-7 text-hover-dark d-flex align-items-center'
                            >
                                <DownloadOutlined /> 
                                <span className='ms-2'>
                                    {item.downloadLinks?.length > 1 
                                        ? `Tüm Dosyaları İndir (${item.downloadLinks.length})` 
                                        : 'Dosyayı indirmek için tıklayınız'}
                                </span>
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>
    ));

    const SkeletonItem = () => (
        <div className='card mb-5 overflow-hidden card-light-shadow' style={{ height: '160px' }}>
            <div className='d-flex h-100'>
                {/* Görsel Alanı İskeleti */}
                <div className='w-150px w-md-200px flex-shrink-0'>
                    <Skeleton.Button active={true} style={{ width: '100%', height: '160px' }} />
                </div>

                {/* Metin Alanı İskeleti */}
                <div className='d-flex flex-column flex-grow-1 p-2 ps-5 overflow-hidden'>
                    {/* Başlık İskeleti */}
                    <Skeleton active paragraph={{ rows: 0 }} title={{ width: '70%' }} />
                    
                    {/* İçerik Satırları */}
                    <div className='flex-grow-1 mt-2'>
                        <Skeleton active title={false} paragraph={{ rows: 2, width: ['100%', '80%'] }} />
                    </div>

                    {/* Alt İndirme Alanı İskeleti */}
                    <div className='mt-2 pt-2 border-top'>
                        <Skeleton.Button active={true} size="small" style={{ width: '120px' }} />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {isFWLoading ? (
                [1/* 2, 3 number of items to if want to increase */].map((i) => <SkeletonItem key={i} />)
            ) : (
                renderedItems
            )}
        </>
    )
}

export { FeaturedNewsDashboard }